module.exports = __webpack_public_path__ + "media/images/no-pulse_heart-icon-c0ce09aa4d5d83d48a1b9f6f5ebfd7ec.svg";